/**
 * Cerco do Boitatá (doc 01, Treta): anel de fogo que encolhe a cada dia, com centros sorteados.
 * Hipóteses de balanceamento, centralizadas aqui.
 */
export const CERCO = {
  /** Raio como fração do raio útil da ilha (R), do dia 0 ao dia 4. */
  fractions: [1.1, 0.7, 0.45, 0.25, 0.1] as const,
  /** O próximo círculo é anunciado ao amanhecer e fecha 20 s depois, em 45 s. */
  announce: 20,
  close: 45,
  /** No anoitecer do dia 4, o colapso final fecha até 0 em 60 s. */
  collapseDay: 4,
  collapse: 60,
  /** Dano fora do anel (fração da Vida máxima por segundo): estágios 1 a 4 e o colapso. */
  damage: [0.03, 0.05, 0.08, 0.12] as const,
  collapseDamage: 0.2,
  /** Aplicado a cada 0,5 s, direto na Vida (sem Patuá nem defesa). */
  tick: 0.5,
  /** Tentativas para o centro novo cair em terra. */
  tries: 32,
  /** O Saci não arremessa quem está a menos disto da borda (doc 06). */
  tossMargin: 10,
} as const;

/** Raio do Cerco no dia (frações do doc 01; depois do dia 4, o do dia 4). */
export const cercoRadius = (day: number, islandRadius: number): number => islandRadius * CERCO.fractions[Math.max(0, Math.min(CERCO.fractions.length - 1, day))]!;

/** Dano por segundo fora do anel: dia 0 e 1 no estágio 1, até o 4; o colapso, 20 %. */
export function cercoDamage(day: number, collapsing: boolean): number {
  if (collapsing) return CERCO.collapseDamage;
  return CERCO.damage[Math.max(0, Math.min(CERCO.damage.length - 1, day - 1))]!;
}

/**
 * Centro do próximo círculo: dentro do atual de modo que o novo caiba inteiro nele
 * (|c_novo − c_velho| ≤ r_velho − r_novo) e em terra; sem terra em 32 tentativas, fica o centro.
 */
export function nextCercoCenter(old: { x: number; z: number }, rOld: number, rNew: number, rand: () => number, isLand: (x: number, z: number) => boolean): { x: number; z: number } {
  const room = Math.max(0, rOld - rNew);
  for (let i = 0; i < CERCO.tries; i++) {
    const a = rand() * Math.PI * 2;
    const r = Math.sqrt(rand()) * room;
    const p = { x: old.x + Math.cos(a) * r, z: old.z + Math.sin(a) * r };
    if (isLand(p.x, p.z)) return p;
  }
  return { x: old.x, z: old.z };
}
